import React, { createContext, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'

import Title from 'components/CommonUI/Title/Title'
import ModalForm from './ModalForm'
import ModalMeterConfiguration from './ModalMeterConfiguration'
import {
  updatePanel,
  addMeter,
  getPanelByIdSelector,
} from 'redux/reducers/devices'
import { useShallowEqualSelector } from 'custom-hooks'

export const MeterContex = createContext()

const PanelEditModal = ({ selectPanelId, handleClose }) => {
  const dispatch = useDispatch()
  const panelData = useShallowEqualSelector(getPanelByIdSelector(selectPanelId))

  const handleSubmittForm = useCallback(
    (values) => {
      dispatch(updatePanel({ id: selectPanelId, ...values }))
    },
    [selectPanelId, dispatch]
  )

  const handleSubmittMeter = useCallback(
    (values) => {
      dispatch(addMeter({ id: selectPanelId, meters: [values] }))
    },
    [dispatch, selectPanelId]
  )

  return (
    <Modal
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className="panel_edit_modal_container"
      keepMounted={false}
      open
    >
      <div className="modal_body_container">
        <div className="modal_body_header">
          <Title
            title={panelData?.name}
            component="h2"
            className="modal_title"
          />
          <IconButton onClick={handleClose} className="modal_close_button">
            <CloseIcon className="modal_close_button_icon" />
          </IconButton>
        </div>
        <div className="modal_body_main">
          <ModalForm
            initialData={{
              id: panelData?.id ?? '',
              name: panelData?.name ?? '',
              description: panelData?.description ?? '',
            }}
            handleSubmittForm={handleSubmittForm}
          />
          <MeterContex.Provider value={handleSubmittMeter}>
            <ModalMeterConfiguration
              meters={panelData?.meters}
              //handleSubmittMeter={handleSubmittMeter}
            />
          </MeterContex.Provider>
        </div>
      </div>
    </Modal>
  )
}

export default PanelEditModal
